import { render, staticRenderFns } from "./BrandSelection.vue?vue&type=template&id=5f3adcc0&scoped=true&"
import script from "./BrandSelection.vue?vue&type=script&lang=js&"
export * from "./BrandSelection.vue?vue&type=script&lang=js&"
import style0 from "./BrandSelection.vue?vue&type=style&index=0&id=5f3adcc0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f3adcc0",
  null
  
)

export default component.exports